import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

function CapsuleLogo() {
  return (
    <div className="capsule-icon">
      <div className="left"></div>
      <div className="right"></div>
    </div>
  );
}

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-navy-900 text-white py-6">
        <div className="max-w-4xl mx-auto px-6">
          <Link to="/login" className="inline-flex items-center text-sm text-navy-300 hover:text-white mb-4">
            <ArrowLeft className="w-4 h-4 mr-1" /> Back to Login
          </Link>
          <div className="flex items-center gap-3">
            <CapsuleLogo />
            <div>
              <h1 className="text-2xl font-heading font-bold">
                <span className="text-mint-400">Pharma</span>
                <span className="text-white">Buddy</span>
              </h1>
              <p className="text-xs text-navy-400 italic">Pharmacist's Most Reliable Partner</p>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h1 className="text-3xl font-heading font-bold text-navy-900 mb-2">Privacy Policy</h1>
          <p className="text-sm text-slate-500 mb-8">Last Updated: February 2026</p>

          <div className="prose prose-slate max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">Introduction</h2>
              <p className="text-slate-600 leading-relaxed">
                Welcome to PharmaBuddy. This Privacy Policy is governed by the Digital Personal Data Protection (DPDP) Act, 2023 (India) and the Drugs and Cosmetics Rules, 1945. PharmaBuddy acts as a "Data Processor" for pharmacy businesses ("Data Fiduciaries").
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">1. Data We Process</h2>
              <ul className="list-disc list-inside space-y-2 text-slate-600">
                <li><strong>Business Data:</strong> GSTIN, Drug License details, and contact information.</li>
                <li><strong>Patient Data:</strong> Name, phone number, and prescription history (processed solely on behalf of the pharmacy).</li>
                <li><strong>Usage Data:</strong> IP addresses and logs for security auditing.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">2. Purpose of Processing</h2>
              <ul className="list-disc list-inside space-y-2 text-slate-600">
                <li>To facilitate digital billing and inventory management.</li>
                <li>To generate mandatory Schedule H1 and X registers for legal compliance.</li>
                <li>To manage SaaS subscription limits (e.g., the 999-customer cap).</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">3. Data Localization</h2>
              <p className="text-slate-600 leading-relaxed">
                In compliance with Indian law, all personal and health data are stored exclusively on secure cloud servers located within the territory of India.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">4. Data Retention</h2>
              <ul className="list-disc list-inside space-y-2 text-slate-600">
                <li><strong>Trial Users:</strong> Data is retained for 15 days of the trial plus a 30-day grace period, after which it is permanently erased.</li>
                <li><strong>Active Subscribers:</strong> Data is retained as long as the subscription is active.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">5. Grievance Redressal</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                As per the DPDP Act 2023, for any grievances, contact our Grievance Officer:
              </p>
              <div className="bg-slate-50 p-4 rounded-lg">
                <p className="text-slate-700"><strong>Email:</strong> support@pharmabuddy.in</p>
                <p className="text-slate-700"><strong>Response Timeline:</strong> Within 72 hours</p>
              </div>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t">
            <Link to="/login">
              <Button className="bg-mint-600 hover:bg-mint-700">
                <ArrowLeft className="w-4 h-4 mr-2" /> Return to Login
              </Button>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-slate-500">
        <div className="flex items-center justify-center gap-4">
          <Link to="/privacy" className="text-mint-600">Privacy Policy</Link>
          <span>•</span>
          <Link to="/terms" className="hover:text-mint-600">Terms of Service</Link>
          <span>•</span>
          <span>© 2026 PharmaBuddy</span>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
